import { Clock, Mail, MapPin, MessageCircle, Phone, Send } from "lucide-react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { serviceGroups, site } from "../data/site";

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Contact Polishing Singapore | Request Surface Assessment"
        description="Contact Polishing Singapore for marble, granite, quartz, terrazzo, tile, parquet, concrete and natural stone polishing or restoration enquiries."
        canonical={`${site.domain}/contact`}
      />
      <PageHero title="Request a Surface Assessment" description="Share the surface type, condition and photos before confirming the right polishing, cleaning, repair or restoration scope." image="/assets/polishing/contact.webp" />
      <section className="section-pad bg-background-50">
        <div className="section-shell grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="surface-card p-6 md:p-8">
            <MessageCircle className="text-primary-700" size={34} />
            <h2 className="mt-5 font-heading text-3xl font-bold">Contact the team</h2>
            <p className="mt-4 text-base leading-8 text-foreground-700">
              Send photos or project details first so the surface type, condition and scope can be reviewed before quoting.
            </p>
            <div className="mt-6 grid gap-4">
              <a href={site.whatsappUrl} className="flex items-start gap-4 rounded-md border border-background-200 bg-background-50 p-4 transition hover:border-primary-300 hover:bg-white">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-700">
                  <MessageCircle size={20} />
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-950">WhatsApp</span>
                  <span className="mt-1 block text-sm text-foreground-700">{site.phone}</span>
                </span>
              </a>
              <a href={site.phoneHref} className="flex items-start gap-4 rounded-md border border-background-200 bg-background-50 p-4 transition hover:border-primary-300 hover:bg-white">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-700">
                  <Phone size={19} />
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-950">Phone</span>
                  <span className="mt-1 block text-sm text-foreground-700">{site.phone}</span>
                </span>
              </a>
              <a href={`mailto:${site.email}?subject=Polishing Singapore enquiry`} className="flex items-start gap-4 rounded-md border border-background-200 bg-background-50 p-4 transition hover:border-primary-300 hover:bg-white">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-700">
                  <Mail size={19} />
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-950">Email</span>
                  <span className="mt-1 block text-sm text-foreground-700">{site.email}</span>
                </span>
              </a>
              <div className="flex items-start gap-4 rounded-md border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-700">
                  <MapPin size={19} />
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-950">Address</span>
                  <span className="mt-1 block text-sm leading-6 text-foreground-700">{site.address.join(", ")}</span>
                </span>
              </div>
              <div className="flex items-start gap-4 rounded-md border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-700">
                  <Clock size={19} />
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-950">Business Hours</span>
                  <span className="mt-1 block text-sm text-foreground-700">{site.businessHours}</span>
                </span>
              </div>
            </div>
            <a href={site.whatsappUrl} className="mt-6 btn-primary">
              WhatsApp now
              <Send size={17} />
            </a>
          </div>

          <div className="surface-card p-6 md:p-8">
            <p className="eyebrow">What to send</p>
            <h2 className="mt-3 font-heading text-3xl font-bold">Useful details before quoting</h2>
            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              {[
                "Surface material if known",
                "Location type: home, office, hotel, restaurant, retail or industrial",
                "Photos of scratches, stains, dullness, cracks or grout condition",
                "Approximate area and urgency",
              ].map((item) => (
                <div key={item} className="rounded-md border border-background-200 bg-background-50 p-4 text-sm font-semibold text-foreground-800">
                  {item}
                </div>
              ))}
            </div>
            <div className="mt-8">
              <h3 className="font-heading text-2xl font-bold">Service groups covered</h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {serviceGroups.map((group) => (
                  <span key={group.slug} className="rounded-full bg-primary-50 px-4 py-2 text-sm font-bold text-primary-800">
                    {group.name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
